export default "__VITE_ASSET__BGQl7xSm__"